
export default {
  deptMembers: [],
  dept: 0,
  total:0,
  max:10,
  offset:0,
  sort: 'member.no',
  order: 'ascending'
};
